import React, { useContext } from 'react';
import { I18n } from '@lingui/react';
import styled from 'styled-components';
import { formatDateForMarkdown } from '@qover/react-intl';
// @ts-ignore
import { ThemeContext } from '@qover/styles';
import type { PriceTransparencyProps } from '@qover/domain';
import { SummaryCard } from './SummaryCard';
import messages from './summaryInsurance.messages';

import { PriceTransparencyInfo } from '../tickets/PriceTransparency';

const PriceTransparencyContainer = styled.div`
  background-color: var(--color-text-quote-03);
  color: var(--color-text-quote-100);
  margin: 40px -20px -20px -20px;
  padding: 16px 20px;
  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    margin: 40px -40px -40px -40px;
    padding: 16px 40px;
  }
`;

type SummaryInsuranceWithPriceProps = {
  contractDuration?: number | null;
  endDate?: string;
  modifyTo: string;
  numberOfInsuredPersons?: number;
  priceTransparency: PriceTransparencyProps;
  startDate?: string;
  summaryCardStyle?: React.CSSProperties;
};

export const SummaryInsuranceWithPrice: React.FC<SummaryInsuranceWithPriceProps> = props => {
  const theme = useContext<any>(ThemeContext);
  const insuranceMessage =
    props.contractDuration != null
      ? messages.insuranceWithDuration
      : messages.insurance;
  return (
    <SummaryCard
      title={messages.insuranceTitle}
      data-test="general.summaryInsurance.modifyButton"
      modifyTo={props.modifyTo}
      style={props.summaryCardStyle}
    >
      <I18n>
        {({ i18n }) =>
          insuranceMessage(
            {
              numberOfInsuredPersons: props.numberOfInsuredPersons,
              endDate: props.endDate
                ? formatDateForMarkdown(i18n.language, new Date(props.endDate))
                : '',
              startDate: props.startDate
                ? formatDateForMarkdown(
                    i18n.language,
                    new Date(props.startDate),
                  )
                : '',
              contractDuration: props.contractDuration,
            },
            messages.renewableContent,
          )
        }
      </I18n>
      {props.children}
      {theme?.featureToggles?.showPriceTransparency && (
        <PriceTransparencyContainer>
          <PriceTransparencyInfo {...props.priceTransparency} />
        </PriceTransparencyContainer>
      )}
    </SummaryCard>
  );
};
